/**
 * 子系统
 */
import http from '@/request/http'

export default {
    // 获取各系统下列表
    systemGetTreeData: params => http.get(`/api/juji/subSystemIndoorEnvironment/getIndoorEnvironmentSystem`, params),
    /******   电梯系统   *****/
    // 获取电梯列表
    subsystemGetLiftList: params => http.get(`/api/juji/subSystemElevator/getElevatorList`, params),
    // 获取维修次数
    subsystemGetMaintenance: params => http.get(`/api/juji/subSystemElevator/getMaintenanceTimesDetails`, params),
    // 获取电梯系统详情
    subsystemGetInfo: params => http.get(`/api/juji/subSystemElevator/getElevatorInfo`, params),

    /******   环境监测   *****/
    subsystemIndoorData: params => http.get(`/api/environmentalMonitoring/getDeviceList`, params), // 获取设备列表
    subsystemIndoorValue: params => http.get(`/api/environmentalMonitoring/getDeviceTelemetryValue`, params), // 遥测数据
    subsystemIndoorAlarm: params => http.get(`/api/environmentalMonitoring/getAlarmRecordList`, params), // 告警列表
    subsystemIndoorType: params => http.get(`/api/environmentalMonitoring/getDeviceTelemetryKey`, params),
    subsystemIndoorCharts: params => http.get(`/api/environmentalMonitoring/getDeviceTelemetryCharts`, params),
    subsystemIndoorListByType: params => http.get(`/api/environmentalMonitoring/getDeviceInMap`, params),


    /******   照明系统 2.0  *****/
    lightingOSGetOverview: params => http.get(`/api/juji/lightingSystem/getOverview`, params),
    lightingOSGetRatedPower: params => http.get(`/api/juji/lightingSystem/getRatedPower`, params),
    lightingOSGetDevice: params => http.get(`/api/juji/lightingSystem/getLightingSystemEquipment`, params),
    lightingOSGetAlarms: params => http.get(`/api/juji/alarm/getAlarmsPageByDeviceType`, params),
    lightingOSGetWorkOrder: params => http.get(`/api/odoo/workOrder/findWorkOrderListByDeviceType`, params),
    //照明系统 -- 用能分析
    LTGOSAnalysisOverview: params => http.get(`/api/juji/lightingSystem/getOverviewOfEnergyUseAnalysis`, params),
    LTGOSAnalysisTable: params => http.get(`/api/juji/lightingSystem/getECDetails`, params),


    OSAnalysisFourEC: params => http.get(`/api/juji/lightingSystem/getTwentyFourHourECTrend`, params),
    OSAnalysisECData: params => http.get(`/api/juji/lightingSystem/getECCharts`, params),


    /******   照明系统   *****/  /******   空调系统   *****/
    subsystemAllGetList: params => http.get(`/api/juji/airConditioner/getStatisticsData`, params),//获取列表
    subsystemAllDetailsList: params => http.get(`/api/juji/airConditioner/getStatisticsPage`, params),
    subsystemControlSwitch: params => http.get(`/api/juji/airConditioner/setDeviceActive`, params),

    /****** 照明系统 -> 系统设备 ******/
    lightSystemDeviceType: params => http.get('/api/juji/lightingSystem/getLightingSystemDeviceType', params),  // 获取设备类型
    lightSystemAssetsTreeMenu: params => http.get('/api/juji/assets/sysTemTree', params),   // 根据设备类型获取资产树形菜单
    lightSystemDevicePage: params => http.get('/api/juji/lightingSystem/getLightingSystemDevicePage', params),  // 照明系统 - 系统设备列表
    lightSystemDeviceDetails: params => http.get('/api/juji/lightingSystem/getLightingSystemDeviceDetails', params), // 照明系统 - 系统设备详情

    /******   光伏系统   *****/
    photovoltaicTreeList: params => http.get(`/api/juji/assets/sysTemTreeByType`, params),
    photovoltaicInverterList: params => http.get(`/api/juji/photovoltaic/getInverterList`, params),
    photovoltaicDescribe: params => http.get(`/api/juji/photovoltaic/getPhotovoltaicBaseInfo`, params),
    photovoltaicManyLine: params => http.get(`/api/juji/photovoltaic/getChartData`, params),
    photovoltaicGetLine: params => http.get(`/api/juji/photovoltaic/getDataListPeriod`, params),
    photovoltaicGetTabList: params => http.get(`/api/juji/photovoltaic/getRecently`, params),
    photovoltaicGetTnverterMsg: params => http.get(`/api/juji/photovoltaic/getInverterInfo`, params),
    photovoltaicGetPowerStationInfo: params => http.get('/api/juji/photovoltaic/getPowerStationInfo', params),    // 光伏系统-光伏总览
    photovoltaicGetMeteorologyInfo: params => http.get('/api/juji/photovoltaic/getMeteorologyInfo', params),     // 光伏主页-气象监测
    photovoltaicGetPvList: params => http.get('/api/juji/photovoltaic/getPvList', params),      // 光伏系统-光伏列表
    photovoltaicGetPVGenElectricityInfo: params => http.get('/api/juji/photovoltaic/getPVGenElectricityInfo', params),      // 光伏系统-发电信息
    photovoltaicFindGenAndPeriodEC: params => http.get('/api/juji/photovoltaic/findGenAndPeriodEC', params),     // 光伏主页-发电趋势、用电分析；光伏效益-用电分析
    photovoltaicGetPvEntityInfo: params => http.get('/api/juji/photovoltaic/getPvEntityInfo', params),  // 光伏系统-实体信息
    photovoltaicGetInverterData: params => http.get('/api/juji/photovoltaic/getInverterData', params),        // 光伏系统-逆变器参数
    photovoltaicFindDeviceTskv: params => http.get('/api/juji/photovoltaic/findDeviceTskv', params),     // 光伏系统->逆变器-设备历史遥测数据

    /******   光伏系统 2.0   *****/
    PVOSPowerStationPSInfo: params => http.get(`/api/juji/photovoltaic/getPowerStationInfo`, params),//光伏主页-电站信息；光伏系统-光伏总览
    PVOSEleInfo: params => http.get(`/api/juji/photovoltaic/generateElectricityInfo`, params),//光伏主页-用电分析；光伏效益-光伏分析
    PVOSPowerTrend: params => http.get(`/api/juji/photovoltaic/findGenAndPeriodEC`, params),//光伏主页-发电趋势、用电分析；光伏效益-用电分析
    PVOSMETMonitor: params => http.get(`/api/juji/photovoltaic/getMeteorologyInfo`, params),//光伏主页-气象监测
    PVOSEnergySaveInfo: params => http.get(`/api/juji/photovoltaic/getEnergySaveInfo`, params),//节能降碳
    PVOSAlarmAnalysis: params => http.get(`/api/juji/photovoltaic/getAlarmStatistic`, params),//告警分析

    PVOSBenefitsTable: params => http.get(`/api/juji/photovoltaic/getDetails`, params),//光伏效益-表格
    PVOSGetCameraInfo: params => http.get(`/api/juji/photovoltaic/getCameraInfo`, params),//监控管理
    PVOSGetAllCameraInfo: params => http.get(`/api/juji/photovoltaic/getCameraInfoAll`, params),//获取所有的摄像头
    

    /*********** 子系统---光伏管理---运维管理   ********* */
  devOpsPatrolTolList: params => http.get(`/api/odoo/inspectionTask/subSystem/getInspectionActedCount`, params),//巡检统计
  devOpsPatrolTable: params => http.get(`/api/odoo/inspectionTask/subSystem/getInspectionInfo`, params),//巡检记录
  devOpsWorksheetsTol: params => http.get(`/api/odoo/workOrder/subsystem/getRepairOrderCount`, params),//工单统计
  devOpsWorksheetsTable: params => http.get(`/api/odoo/workOrder/subsystem/getRepairOrderInfo`, params),//工单记录
  devOpsWorksheetsCharts: params => http.get(`/api/odoo/workOrder/subsystem/getRepairOrderGroupCount`, params),
  devOpsAlarmTol: params => http.get(`/api/juji/subsystem/getAlarmCount`, params),//告警统计
  devOpsAlarmCharts: params => http.get(`/api/juji/subsystem/getAlarmGroupCount`, params),


    // 获取功率密度
    subsystemPowerRanking: params => http.get(`/api/juji/subSystemLighting/getPowerRanking`, params),
    // 获取同比环比
    subsystemYoyMomInfo: params => http.get(`/api/juji/subSystemLighting/getYoyMomInfo`, params),
    // 组织架构区域列表
    airConditionerGetTree: params => http.get(`/api/juji/assets/airConditionerTree`, params),

    /******   空调系统 2.0   *****/
    //空调系统界面
    ACRGetOverviewOfCentralAirConditioning: params => http.get(`/api/juji/airConditioner/getOverviewOfCentralAirConditioning`, params),//获取中央空调概览
    ACRGetOverviewOfSplitAirConditioner: params => http.get(`api/juji/airConditioner/getOverviewOfSplitAirConditioner`, params),//获取分体式空调概览
    //中间部分
    ACRGetCentralAirConditioning: params => http.get(`/api/juji/airConditioner/getCentralAirConditioning`, params),//获取中央空调列表
    ACRGetCentralAirConditioningHostList: params => http.get(`/api/juji/airConditioner/getCentralAirConditioningHostList`, params),//获取中央空调主机列表
    ACRGetCoolingTowerList: params => http.get(`/api/juji/airConditioner/getCoolingTowerList`, params),//获取冷却塔列表
    ACRGetDiversionWaterCollectorList: params => http.get(`/api/juji/airConditioner/getDiversionWaterCollectorList`, params),//获取分水器、集水器列表
    ACRGetWaterPumpCollectorList: params => http.get(`/api/juji/airConditioner/getWaterPumpCollectorList`, params),//冷冻、冷却水泵
    ACRGetWarmWaterPumpList: params => http.get(`/api/juji/airConditioner/getWarmWaterPumpList`, params),//暖水泵
    ACRGetEnvironmentalMonitoring: params => http.get(`/api/juji/airConditioner/getEnvironmentalMonitoring`, params),//环境监测
    ACRGetHostEnergyEfficiency: params => http.get(`/api/juji/airConditioner/getHostEnergyEfficiency`, params),//主机能效
    ACRGetBoilerEnergyEfficiency: params => http.get(`/api/juji/airConditioner/getBoilerEnergyEfficiency`, params),//锅炉能效
    ACRGetObtainBoilerList: params => http.get(`/api/juji/airConditioner/getObtainBoilerList`, params),//锅炉机组
    ACRControlTemp: params => http.get(`/api/juji/airConditioner/setDeviceTemperatureBatch`, params),//一键控温

    //能效界面
    ACRGetEquipmentStatusStatistics: params => http.get(`/api/juji/airConditioner/getEquipmentStatusStatistics`, params),//设备状态统计
    ACRGetIPLVAndSEER: params => http.get(`api/juji/airConditioner/getIPLVAndSEER`, params),//获取IPLV和额定SEER
    ACRGetEnergyEfficiencyIndicators: params => http.get(`api/juji/airConditioner/getEnergyEfficiencyIndicators`, params),//制冷模式能效指标
    ACRGetEnergyConsumptionIndicators: params => http.get(`api/juji/airConditioner/getEnergyConsumptionIndicators`, params),//制冷模式能耗指标
    ACRGetHeatingEnergyEfficiencyIndicators: params => http.get(`api/juji/airConditioner/getHeatingEnergyEfficiencyIndicators`, params),//制热模式能效指标
    ACRGetHeatingEnergyConsumptionIndicators: params => http.get(`api/juji/airConditioner/getHeatingEnergyConsumptionIndicators`, params),//制热模式能耗指标
    ACRGetHostLoad: params => http.get(`api/juji/airConditioner/getHostLoad`, params),//主机负荷
    ACRGetDeviceList: params => http.get(`api/juji/airConditioner/getDeviceList`, params),//设备列表
    ACRGetRatedParameters: params => http.get(`api/juji/airConditioner/getRatedParameters`, params),//额定参数
    ACRGetChartsByParameters: params => http.get(`api/juji/airConditioner/getChartsByParameters`, params),//根据参数获取图表


    ACRGetMachineRoomList: params => http.get(`/api/juji/airConditioner/getComputerRoomControl`, params),//系统控制-机房列表
    ACRGetStrategyList: params => http.get(`/api/juji/airConditioner/getStrategyList`, params),//系统控制-策略列表
    ACRSearchStrategyList: params => http.get(`/api/juji/airConditioner/getStrategy`, params),//系统控制-查询策略
    ACRSearchDevicesList: params => http.get(`/api/juji/device/getDevicesByAssetAndTypes`, params),//系统控制-策略-查询风机盘管列表
    ACRSaveStrategy: params => http.post(`/api/juji/airConditioner/saveStrategy`, params),//系统控制-策略-保存策略
    ACRStrategyRecordList: params => http.get(`/api/juji/airConditioner/getStrategyRecordList`, params),//系统控制-策略-历史记录
    ACRStrategyCarryOut : params => http.get(`/api/juji/airConditioner/setStrategyActive`, params),//系统控制-策略-执行策略
    ACRDeleteStrategy: (params, id) =>
    http.delete(
      `/api/juji/airConditioner/deleteStrategy/${id}`,
      params
    ),//系统控制-策略-删除策略



    /****** 空调系统2.0 -> 用能分析******/
    ACOSUseGetOverview: params => http.get(`/api/juji/airConditioner/getOverviewOfEnergyUseAnalysisForThree`, params),//总览
    ACOSUseGetECAnalysis: params => http.get(`/api/juji/airConditioner/getElectricityAnalysis`, params),//中央空调用电分析
    ACOSUseGetRunTime: params => http.get(`/api/juji/airConditioner/getAirConditioningOperationDuration`, params),//空调运行时间排行
    ACOSUseGetECTable: params => http.get(`/api/juji/airConditioner/getECDetails`, params),//用电详情表


  /****** 生活热水系统3.0 -> 用能分析******/
    // 用能分析
    DHWAnalysisOverview: params => http.get(`/api/juji/domesticHotWater/getOverviewOfEnergyUseAnalysisForThree`, params),//概述
    DHWAnalysisGasTop: params => http.get(`/api/juji/domesticHotWater/getDomesticHotWaterAnalysis`, params),//用气top
    DHWAnalysisRunTime: params => http.get(`/api/juji/domesticHotWater/getDeviceRunTime`, params),//运行时长
    DHWAnalysisEcData: params => http.get(`/api/juji/lightingSystem/getEnergyCharts`, params),//用能趋势
    DHWAnalysisEcTable: params => http.get(`/api/juji/domesticHotWater/getDomesticHotWaterDetails`, params),//用电详情表


    //生活热水系统界面
    DHWGetDomesticHotHaterList: params => http.get(`/api/juji/domesticHotWater/getDomesticHotHaterList`, params),//获取生活热水系统列表
    DHWGetBoilerEnergyEfficiency: params => http.get(`/api/juji/domesticHotWater/getBoilerEnergyEfficiency`, params),//锅炉能效
    DHWGetHeatStorageWaterTankList: params => http.get(`/api/juji/domesticHotWater/getHeatStorageWaterTankList`, params),//保温水箱
    DHWGetWarmWaterPumpList: params => http.get(`/api/juji/domesticHotWater/getWarmWaterPumpList`, params),//热水循环泵列表
    DHWGetObtainBoilerList: params => http.get(`/api/juji/domesticHotWater/getObtainBoilerList`, params),//锅炉列表
    DHWGetAirSourceHeatPumpList: params => http.get(`/api/juji/domesticHotWater/getAirSourceHeatPumpList`, params),//空气源热泵列表

    //生活热水系统能效界面
    DHWGetEquipmentStatusStatistics: params => http.get(`/api/juji/domesticHotWater/getEquipmentStatusStatistics`, params),//状态统计
    DHWGetHeatingEnergyEfficiencyIndicators: params => http.get(`/api/juji/domesticHotWater/getHeatingEnergyEfficiencyIndicators`, params),//制热模式能效指标
    DHWGetHeatingEnergyConsumptionIndicators: params => http.get(`/api/juji/domesticHotWater/getHeatingEnergyConsumptionIndicators`, params),//制热模式能耗指标





    /******    动力系统   ******/
    // 动力系统
    DynamicalDeviceStatistics: params => http.get(`/api/juji/dynamicalSystem/getDynamicalDeviceStatistics`, params),//概览-状态统计
    DynamicalOPERATIONAL: params => http.get(`/api/juji/dynamicalSystem/getDeviceRunningState`, params),//概览-运转状态
    DynamicalOverviewRealPower: params => http.get(`/api/juji/dynamicalSystem/getDynamicalSystemRealPower`, params),//概览-实时功率
    DynamicalOverviewEC: params => http.get(`/api/juji/dynamicalSystem/getEnergyConsumptionAndFeedback`, params),//概览-能耗及回馈
    DynamicalOverviewRunningDistance: params => http.get(`/api/juji/dynamicalSystem/getDynamicalDistanceTraveled`, params),//运行分析-运行距离
    DynamicalOverviewAlarmReason: params => http.get(`/api/juji/alarm/getAlarmRangeCountByTypes`, params),//运行分析-报警分析
    // 运行状态
    DynamicalGetAssetTree: params => http.get(`/api/juji/relation/getAssetsAndDevicesTree`, params),//动力系统资产树
    DynamicalStateRealTime: params => http.get(`/api/juji/dynamicalSystem/getRealTimeStatus`, params),//实时状态
    DynamicalStateEC: params => http.get(`/api/juji/dynamicalSystem/getEnergyConsumption`, params),//能耗
    DynamicalStateOperationsAnalysis: params => http.get(`/api/juji/dynamicalSystem/getOperationsAnalysis`, params),//运转分析
    DynamicalStateEnvironment: params => http.get(`/api/juji/dynamicalSystem/getDynamicalEnvironmentalMonitoring`, params),//环境监测
    DynamicalStateAlarm: params => http.get(`/api/juji/alarm/getAlarmHandleAnalysis`, params),//报警分析
    DynamicalStateDevOpsAnalysis: params => http.get(`/api/juji/dynamicalSystem/getDevOpsAnalysis`, params),//运维分析
    DynamicalStateRealTimeCharts: params => http.get(`/api/juji/dynamicalSystem/getDynamicalPowerCharts`, params),//实时状态图表
    DynamicalStateECCharts: params => http.get(`/api/juji/dynamicalSystem/getEnergyConsumptionCharts`, params),//能耗图表
    DynamicalStateRunAnalysisCharts: params => http.get(`/api/juji/dynamicalSystem/getOperationsAnalysisCharts`, params),//运转分析图表
    DynamicalStateDevOpsCharts: params => http.get(`/api/juji/dynamicalSystem/getDevOpsAnalysisCharts`, params),//运维分析图表
    DynamicalStateAlarmLevelCharts: params => http.get(`/api/juji/alarm/getAlarmLevelAnalysis`, params),//报警等级图表
    DynamicalStateGetElevatorArchives: params => http.get(`/api/juji/dynamicalSystem/getElevatorArchives`, params),//电梯档案
    DynamicalStateEditElevatorArchives: params => http.post(`/api/juji/dynamicalSystem/saveElevatorArchives`, params),//修改电梯档案
    // 用能分析
    DynamicalEnergyOverview: params => http.get(`/api/juji/dynamicalSystem/getDynamicOverviewOfEnergyUseAnalysis`, params),//总览
    DynamicalEnergyEquipmentEnergy: params => http.get(`/api/juji/dynamicalSystem/getEquipmentEnergyAnalysis`, params),//设备用能分析
    DynamicalEnergyElectricitySaving: params => http.get(`/api/juji/dynamicalSystem/getEquipmentEnergyTop`, params),//用电节电
    DynamicalEnergyFourEC: params => http.get(`/api/juji/dynamicalSystem/getTwentyFourHourTrend`, params),//24小时用电时长
    DynamicalEcTable: params => http.get(`/api/juji/dynamicalSystem/getDynamicalSystemDetails`, params),//用电详情表


    /******    配电系统   ******/
    DSGetOverviewOfPowerDistribution: params => http.get(`/api/juji/distributing/getOverviewOfPowerDistribution`, params),//概览
    DSGetBasicInformation: params => http.get(`/api/juji/distributing/getBasicInformation`, params),//基本信息
    DSGetDistributingPvList: params => http.get(`/api/juji/distributing/getDistributingPvList`, params),//视频信息
    DSGetRunningState: params => http.get(`/api/juji/distributing/getRunningState`, params),//运行状态
    DSGetAlarmsPageByAssetType: params => http.get(`/api/juji/alarm/getAlarmsPageByAssetType`, params),//报警列表
    DSGetTrendChart: params => http.get(`/api/juji/distributing/getTrendChart`, params),//用电趋势图表
    DSGetHasSvgAssets: params => http.get(`/api/juji/distributing/getHasSvgAssets`, params),//根据属性查询资产
    PDSGetDeviceParameter: params => http.get(`/api/juji/distributing/getDistributingRunStateParams`, params),  // 获取参数
    PDSGetRunStateCharts: params => http.get(`/api/juji/distributing/getDistributingRunStateCharts`, params),  // 运行状态图表
    PDSGetDemandAnalysis: params => http.get(`/api/juji/distributing/getDistributingDemandAnalysis`, params),  // 需量分析图表
    PDSGetHarmonicParameters: params => http.get(`/api/juji/distributing/getHarmonicParameters`, params),  // 电能质量
    PDSGetHarmonicCharts: params => http.get(`/api/juji/distributing/getHarmonicCharts`, params),  // 电能质量图表
    
    /******    svg   ******/
    SVGGetTelemetryAndAttributeValues: params => http.get(`/api/juji/device/getTelemetryAndAttributeValues`, params),//svg


    /******    建筑系统   ******/
    // 区域设备
    BMSGetRgionDeviceCount: params => http.get(`/api/juji/buildingSystem/getRgionDeviceCount`, params),  // 获取列表
    BMSGetRgionSecsorDetail: params => http.get(`/api/juji/buildingSystem/getRgionSecsorDetail`, params),  // 传感器详情
    BMSGetRgionMeasurementDetail: params => http.get(`/api/juji/buildingSystem/getRgionMeasurementDetail`, params),  // 量测设备详情
    BMSGetCustomEnergyCount: params => http.get(`/api/juji/buildingSystem/getCustomEnergyCount`, params),  // 用能设备列表
    // 使用说明
    BMSInstructionsGetDetails: params => http.get(`/api/juji/buildingSystem/getDirectionsForUse`, params),  // 获取使用详情信息
    BMSInstructionsSetDetails: params => http.post(`/api/juji/buildingSystem/updateDirectionsForUse`, params),  // 修改使用详情信息
}

